/**
 * MobileAppHeader — shared sticky mobile top bar.
 *
 * Layout:  [Trainnova icon]  [compact team selector]  [notification bell]
 *
 * - Owns the iOS safe-area (paddingTop) and sticks to the true top of the
 *   viewport so the header background bleeds into the status bar.
 * - Reuses the existing MobileTeamHeader (team/child switch logic untouched).
 * - Reuses the canonical in-app notification bell + center.
 */

import React from 'react';
import MobileTeamHeader from './MobileTeamHeader';
import MobileNotificationBell from '../notifications/MobileNotificationBell';

export default function MobileAppHeader() {
  return (
    <div
      className="sticky top-0 z-40 bg-[var(--t-bg1)]/85 backdrop-blur-xl border-b border-[rgb(var(--tn-border-ffffff))]/[0.05]"
      style={{ paddingTop: 'env(safe-area-inset-top)' }}
      data-testid="mobile-app-header"
    >
      <div className="flex items-center gap-2 px-3 h-11">
        <img
          src="/trainnova-appicon-fixed.png"
          alt="Trainnova"
          className="h-8 w-8 rounded-[10px] shrink-0"
          data-testid="mobile-header-brand"
        />
        <div className="flex-1 min-w-0">
          <MobileTeamHeader compact className="!px-3 !rounded-full" />
        </div>
        <MobileNotificationBell />
      </div>
    </div>
  );
}
